import { Button, Spinner } from '@chakra-ui/react';
import { setUser } from '@sentry/react';
import { useEffect, useState } from 'react';

import { Alert, RouterLink, VStack } from '@/components';

import { useWhoAmI } from '../WhoAmI';

const loggingOut = 'Logging out...';
export const logoutError =
  'There was a problem logging out, please refresh the page';

export const LogOut = () => {
  const { logOut } = useWhoAmI();
  const [logoutState, setLogoutState] = useState<string>(loggingOut);
  const [error, setError] = useState<typeof logoutError | null>(null);
  const isLoading = logoutState == loggingOut;

  useEffect(() => {
    const logout = async () => {
      try {
        await logOut();
        setUser(null);
        setLogoutState('Logged out');
      } catch {
        setError(logoutError);
      }
    };
    logout();
  }, [logOut]);

  return (
    <VStack className="LogOut">
      {error ? (
        <Alert status="error" variant="solid" title={error} />
      ) : (
        <Alert
          status="success"
          variant="solid"
          title={logoutState}
          startElement={isLoading ? <Spinner /> : null}
        />
      )}

      <Button asChild type="submit" colorPalette="accent" pill width="full">
        <RouterLink to="../login">Back to Login</RouterLink>
      </Button>
    </VStack>
  );
};
